import React from "react";
import "./TermsAndConditions.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";
const FraudAwareness = () => {
  return (
    <div className="page-body">
      <div className="terms-container">
             <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
          <h5 className="page-title mt-3"><strong>Fraud Awareness</strong></h5>
          <div className="breadcrumb m-0 text-end">
             <Link to="/compliance-center">Compliance Center</Link>  &nbsp;&gt;&nbsp;
            <strong>Fraud Awareness</strong>
          </div>
        </div>
        {/* ✅ Carousel Starts Here */}
        <div id="fraudCarousel" className="carousel slide mb-4" data-bs-ride="carousel">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img
                src="/assets/images/fraud1.png"
                className="d-block w-100"
                alt="Fraud Alert 1"
              />
            </div>
            <div className="carousel-item">
              <img
          src="/assets/images/fraud2.png"
                className="d-block w-100"
                alt="Fraud Alert 2"
              />
            </div>
            <div className="carousel-item">
              <img
               src="/assets/images/fraud3.png"
                className="d-block w-100"
                alt="Fraud Alert 3"
              />
            </div>
             <div className="carousel-item">
              <img
               src="/assets/images/fraud4.png"
                className="d-block w-100"
                alt="Fraud Alert 4"
              />
            </div>
             <div className="carousel-item">
              <img
               src="/assets/images/fraud5.png"
                className="d-block w-100"
                alt="Fraud Alert 5"
              />
            </div>
             <div className="carousel-item">
             <img
    src="/assets/images/fraud6.png"
    className="d-block w-100"
    alt="Fraud Alert 6"
/>
            </div>
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#fraudCarousel" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#fraudCarousel" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
        {/* ✅ Carousel Ends Here */}

        <em><span>Dated: February 6, 2021</span></em>

        <p><strong><span>Master Directions on Prepaid Payment Instruments (PPIs) (Updated as on November 12, 2021) Issued by RBI</span></strong></p>

        <p>
        Reliable inputs have been received on a new modus operandi of social engineering frauds using mobile numbers resembling a T Wallet toll-free number and registering these mobile numbers in the name of that T Wallet on caller identification mobile apps such as Truecaller. The modus operandi is given below.
2. Suppose that a T Wallet toll free number is 1800 123 1234 (e.g.). The fraudster obtains a number, say 800 123 1234, resembling the T Wallet toll-free number and registers successfully on the Truecaller app (or any caller identification application) as the toll- free number of that T Wallet. An unsuspecting customer (victim) looking to contact the T Wallet, contacts the fraudster’s number registered on the Truecaller application (800 123 1234) instead of the genuine toll-free number of the T Wallet (1800 123 1234). The person (fraudster) attending this call then lures the victim into providing sensitive details such as debit/ credit card credentials, username, OTP, etc. to access the victim’s account and carry out fraudulent transactions.
        </p>
      </div>
    </div>
  );
};

export default FraudAwareness;
